import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Header = styled.div`
  text-align: ${(props) => props.style.textAlign || 'center'};
  background-color: ${(props) => props.style.backgroundColor || '#000'};
  color: ${(props) => props.style.color || '#fff'};
  padding: ${(props) => props.style.padding || '1rem 0'};
  width: 100%;
`;

export const PanelHeader = ({ className, style, children }) => (
  <Header className={className} style={style}>
    {children}
  </Header>
);

PanelHeader.defaultProps = {
  className: '',
  style: {},
};

PanelHeader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.shape({
    textAlign: PropTypes.oneOf(['left', 'center', 'right']),
    backgroundColor: PropTypes.string,
    color: PropTypes.string,
    padding: PropTypes.string,
  }),
  children: PropTypes.node.isRequired,
};
